import styles from './styles.module.scss';
import { FC } from 'react';

export const WipNo: FC<{ wipNo?: number }> = ({ wipNo }) => {
  return <span className={styles.container}>WIP {wipNo ?? '-'}</span>;
};
